import React, { createContext, useContext, ReactNode } from 'react';
import { User } from '../../items/interfaces/IUsers';

interface UserContextType {
    dbUser: User | null;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ dbUser: User | null; children: ReactNode }> = ({ dbUser, children }) => {
    return <UserContext.Provider value={{ dbUser }}>{children}</UserContext.Provider>;
};

/**
 * Hook to access the current authenticated user from database
 * @returns {UserContextType} Object containing dbUser (User | null)
 */
export const useDbUser = (): UserContextType => {
    const context = useContext(UserContext);
    if (context === undefined) {
        throw new Error('useDbUser must be used within a UserProvider');
    }
    return context;
};
